var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Review',{attrs:{"rating":_vm.rating,"title":_vm.title,"review-date":_vm.reviewDate,"description":_vm.description}})
}
var staticRenderFns = []

export { render, staticRenderFns }